import React, { forwardRef } from "react";
import { PopperChildrenProps } from "react-popper";
import { motion } from "framer-motion";
import { PopoverPopperProps } from ".";

interface PopoverElementProps
  extends PopoverPopperProps,
    Omit<PopperChildrenProps, "placement" | "style"> {}

export const PopoverElement = forwardRef<HTMLDivElement, PopoverElementProps>(
  (
    {
      style,
      placement,
      arrowProps,
      className = "",
      title,
      children,
      ...divProps
    },
    ref
  ) => (
    <motion.div
      ref={ref}
      style={style}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      data-placement={placement}
      role="tooltip"
      className={`popover bs-popover-${placement} ${className}`}
      {...divProps}
    >
      <div className="popover-arrow" {...arrowProps}></div>
      {title && <h3 className="popover-header">{title}</h3>}
      <div className="popover-body">{children}</div>
    </motion.div>
  )
);